import { Controller } from '@hotwired/stimulus'
import { BROADBAND_PROVIDER_ORDER } from '../../utils/providers-listing'

export default class extends Controller {
  change(event) {
    const value = event.target.value
    const selectedProvider = BROADBAND_PROVIDER_ORDER.find((provider) => {
      return provider.name === value
    })
    window.location = `/broadband/providers/${selectedProvider.slug}/`
  }
}
